import { atom } from "recoil";
import { PurchaseModel } from "../Models/PurchaseModel";
export const purchaseSate = atom({
  key: "purchaseSate", // unique ID (with respect to other atoms/selectors)
  default: new PurchaseModel(), // default value (aka initial value)
});
